module.exports = "build/assets/graph2.8e6a0ac0.png";